// this is here for side effect because @mui developers are bad people
import { createTheme } from "@mui/material";

// emulate webpack
window.global ||= window;

createTheme();
